/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Intent } from '../model';
/**
 * IntentApi - axios parameter creator
 * @export
 */
export const IntentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This reads intent details.
         * @summary Read intent
         * @param {string} id Intent ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIntent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('readIntent', 'id', id)
            const localVarPath = `/v2/public/intents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntentApi - functional programming interface
 * @export
 */
export const IntentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntentApiAxiosParamCreator(configuration)
    return {
        /**
         * This reads intent details.
         * @summary Read intent
         * @param {string} id Intent ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readIntent(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Intent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readIntent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntentApi - factory interface
 * @export
 */
export const IntentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntentApiFp(configuration)
    return {
        /**
         * This reads intent details.
         * @summary Read intent
         * @param {string} id Intent ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readIntent(id: string, options?: any): AxiosPromise<Intent> {
            return localVarFp.readIntent(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntentApi - interface
 * @export
 * @interface IntentApi
 */
export interface IntentApiInterface {
    /**
     * This reads intent details.
     * @summary Read intent
     * @param {string} id Intent ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntentApiInterface
     */
    readIntent(id: string, options?: AxiosRequestConfig): AxiosPromise<Intent>;

}

/**
 * IntentApi - object-oriented interface
 * @export
 * @class IntentApi
 * @extends {BaseAPI}
 */
export class IntentApi extends BaseAPI implements IntentApiInterface {
    /**
     * This reads intent details.
     * @summary Read intent
     * @param {string} id Intent ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntentApi
     */
    public readIntent(id: string, options?: AxiosRequestConfig) {
        return IntentApiFp(this.configuration).readIntent(id, options).then((request) => request(this.axios, this.basePath));
    }
}
